import { useContext, useState } from "react";

import type { StreamChat } from "stream-chat";
import { Chat } from "stream-chat-react";

import { UserContext } from "../../../../helpers";
import { MobileContext } from "../../context/MobileContext";
import { ChannelContainer } from "../ChannelContainer/ChannelContainer";
import { ChannelListContainer } from "../ChannelListContainer/ChannelListContainer";
import "stream-chat-react/dist/css/v2/index.css";
import "./MessageInbox.css";

interface MessageInboxProps {
  client: StreamChat;
}

const MessageInbox = ({ client }: MessageInboxProps) => {
  const { user } = useContext(UserContext);
  const [isMobileListVisible, setIsMobileListVisible] = useState(true);

  const filters = {
    type: "team",
    team: `company-${user.company.id}`,
    members: { $in: [user.id.toString()] },
  };

  const options = { state: true };
  const sort = { unread_count: -1 } as const;

  const handleChannelFilter = (channels: any) => {
    return channels.filter((channel: any) => {
      const team = channel.data?.team;
      if (!team || team !== `company-${user.company.id}`) {
        return false;
      }
      return true;
    });
  };

  return (
    <div
      className={`app__wrapper ${
        isMobileListVisible ? "show-list" : "show-chat"
      }`}
    >
      <Chat client={client} theme="team">
        <MobileContext.Provider
          value={{ isMobileListVisible, setIsMobileListVisible }}
        >
          <ChannelListContainer
            {...{
              filters,
              options,
              sort,
              channelRenderFilterFn: handleChannelFilter,
            }}
          />
          <ChannelContainer />
        </MobileContext.Provider>
      </Chat>
    </div>
  );
};

export default MessageInbox;
